import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function NotComparisonReadOnlyInlineButtons({ children }) {
    const { comparisonReadOnly, hasAcceptReject } = useBoundContext()
    if (!comparisonReadOnly || hasAcceptReject) {
        return children
    }
    return null
}
